<template>
  <div class="widget" :class="{'no-header': !hasHeader, 'no-border': embedded}">
    <header class="widget-header flex-wrap" :class="headerClass" v-if="hasHeader">
      <span v-if="headerIcon" class="widget-header-icon" @click="$emit('headerIconClicked')">
        <i :class="headerIcon"></i>
      </span>
      <div class="widget-header-title" @click="toggleCollapse">
        <slot name="header"><span>{{headerText}}</span></slot>
      </div>
      <slot name="headerActions" v-if="!collapsed_"></slot>
    </header>
    <div class="widget-body" v-show="!collapsed_">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'vuestic-widget',
    props: {
      headerText: String,
      headerIcon: {},
      collapsible: Boolean,
      collapsed: Boolean,
      embedded: Boolean,
    },
    data () {
      return {
        collapsed_: false,
      };
    },
    computed: {
      hasHeader () {
        return this.headerText || this.headerIcon || this.$slots.headerActions || this.$slots.header;
      },
      headerClass () {
        return this.collapsible ? 'collapsible' : null;
      },
    },
    methods: {
      toggleCollapse () {
        if (this.collapsible) {
          this.collapsed_ = !this.collapsed_;
        }
      },
    },
    watch: {
      collapsed: {
        immediate: true,
        handler (v) {
          this.collapsed_ = v;
        },
      },
      collapsed_ (v) {
        this.$emit('update:collapsed', v);
      },
    },
  };
</script>

<style lang="scss">
  @import "../../../sass/_variables.scss";

  .widget {
    background    : $widget-bg;
    box-shadow    : $widget-box-shadow;
    margin-bottom : $widget-mb;
    padding       : 0;

    &.no-header {
      .widget-body {
        height : $widget-body-no-header-height;
      }
    }

    &.no-border {
      box-shadow    : none;
      margin-bottom : 0;
      background    : inherit;
    }

    &.larger-padding {
      .widget-body {
        padding : $widget-larger-padding;
      }
    }

    &.no-h-padding {
      .widget-body {
        padding-left  : 0;
        padding-right : 0;
      }
    }

    &.no-v-padding {
      .widget-body {
        padding-top    : 0;
        padding-bottom : 0;
      }
    }

    &.brand-info {
      background-color : $brand-info;
      color            : $white;
      box-shadow       : $widget-info-shadow;
    }

    &.brand-danger {
      background-color : $brand-danger;
      color            : $white;
      box-shadow       : $widget-danger-shadow;
    }

    &.info-widget {
      border-top : $info-widget-border;

      &.brand-info {
        border-top-color : $brand-info;
      }

      &.brand-danger {
        border-top-color : $brand-danger;
      }

      &.brand-success {
        border-top-color : $brand-success;
      }

      &.brand-warning {
        border-top-color : $brand-warning;
      }

      &.brand-primary-light {
        border-top-color : $brand-primary-light;
      }

      &.disabled {
        border-top-color : $gray;
      }
    }

    .widget-body {
      height  : $widget-body-with-header-height;
      padding : $widget-padding;
    }

    .widget-header {
      min-height    : $widget-header-height;
      padding       : 0 $widget-padding;
      border-bottom : $widget-header-border;
      font-size     : $font-size-larger;
      font-weight   : 600;
      display       : flex;
      align-items   : center;

      &-icon {
        padding     : 0 $widget-padding;
        margin-left : -$widget-padding;
        height      : 100%;
        display     : flex;
        align-items : center;
        cursor      : pointer;
      }

      &-title {
        flex        : 1;
        align-self  : stretch;
        display     : flex;
        align-items : center;
        height      : $widget-header-height;
      }

      &.collapsible {
        cursor : pointer;

        &:hover {
          background-color : rgba(0, 0, 0, .03);
        }
      }

      @media print {
        > :not(.widget-header-title) {
          display : none !important;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget.vue